<template>


	<div class="scored">
		<vs-row>
			<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" class="m-4 p-d">
				<el-date-picker
					style="width:100%"
					v-model="yearmonth"
					format="yyyy-MM-dd"
					value-format="yyyy-MM-dd"
					type="monthrange"
					range-separator="至"
					start-placeholder="开始月份"
					end-placeholder="结束月份">
				</el-date-picker>

			</vs-col>
			<vs-col vs-type="flex" vs-align="center" vs-w="4">
				<el-cascader style="width:360px" v-model="deptid" :options="options" placeholder="请选择部门"
				             :props="{ checkStrictly: true,value:'id',label:'name'}" class="ml-4"></el-cascader>
				<!-- <el-input v-model="deptid" placeholder="请选择部门" class="ml-4"></el-input> -->
			</vs-col>
		</vs-row>
		<vs-row class="mb-4">
			<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5">
				<el-input v-model="name" placeholder="请输入姓名" class="ml-4 mr-4"></el-input>
				<vs-select class="selectExample" v-model="status">
					<vs-select-item value="2" text="评分中"/>
					<vs-select-item value="10" text="已完成"/>
					<vs-select-item value="11" text="已抽检"/>
				</vs-select>
			</vs-col>
			<vs-col vs-type="flex" vs-align="center" vs-w="5">
				<vs-button color="primary" type="filled" @click="search()" class="ml-12 mr-8">搜索</vs-button>
				<vs-button color="primary" type="filled" @click="reset()" class="mr-8">重置</vs-button>
				<vs-button color="success" type="filled" @click="exportall()">批量导出</vs-button>
			</vs-col>
		</vs-row>
		<vs-table ref="table" :max-items="10" :data="culturelist">
			<template slot="thead">
				<vs-th>序号</vs-th>
				<vs-th>名称</vs-th>
				<vs-th>姓名</vs-th>
				<vs-th>部门</vs-th>
				<vs-th>手机号</vs-th>
				<vs-th>创建时间</vs-th>
				<vs-th>提交时间</vs-th>
				<vs-th>自评分</vs-th>
				<vs-th>最终得分</vs-th>
				<vs-th>状态</vs-th>
				<vs-th>操作</vs-th>
			</template>
			<template slot-scope="{data}">
				<tbody v-if="culturelist.length>0">
				<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
					<vs-td>
						<p class="product-name font-medium">{{ indextr + 1 }}</p>
					</vs-td>
					<vs-td>
						<p class="product-category">{{ tr.name }}</p>
					</vs-td>
					<vs-td>
						<p class="product-category">{{ tr.userName }}</p>
					</vs-td>
					<vs-td>
						<p class="product-category">{{ tr.deptName }}</p>
					</vs-td>
					<vs-td>
						<p class="product-price">{{ tr.phone }}</p>
					</vs-td>
					<vs-td>
						<p class="product-price">{{ tr.assessTime }}</p>
					</vs-td>
					<vs-td>
						<p class="product-price">{{ tr.updateTime ? tr.updateTime : '------' }}</p>
					</vs-td>
					<vs-td>
						<p class="product-price">{{ tr.totalScore }}</p>
					</vs-td>
					<vs-td>
						<p class="product-price">{{ tr.finalScore || "待评分" }}</p>
					</vs-td>
					<vs-td>
						<p class="product-price"
						   :class="tr.status==11?'text-danger':tr.status==2?'text-primary':'text-success'">
							{{ tr.status == 11 ? "已抽检" : tr.status == 2 ? "待考核" : "已完成" }}</p>
					</vs-td>
					<vs-td>
						<vs-button class="mr-4" v-if="isexit" color="danger" type="filled" size="small"
						           @click.stop="reject(tr.id)">驳回
						</vs-button>
            <vs-button class="mr-4" v-if="hasEditAssessTime" type="filled" @click.stop="editAssessTime(tr)" size="small">
              编辑考核时间
            </vs-button>
            <vs-button class="mr-4" color="primary" type="filled" @click.stop="details(tr)" size="small">
							详情
						</vs-button>
						<vs-button color="success" type="filled" @click="exportexcel(tr.id)" size="small">导出Excel
						</vs-button>
					</vs-td>
					<template class="expand-user" slot="expand">
						<div class="con-expand-users w-full p-4">
							<el-descriptions v-for="(item,index) in tr.reviewerTotalScore" :key="index" border
							                 :column="1" class="mb-4" labelClassName="expandlabel">
								<el-descriptions-item label="审核员">{{ item.name }}</el-descriptions-item>
								<el-descriptions-item label="审核时间">{{ item.createTime }}</el-descriptions-item>
								<el-descriptions-item label="总评语">{{ item.remarks }}</el-descriptions-item>
								<el-descriptions-item label="评分">
									<el-tag size="small">{{ item.totalScore }}</el-tag>
								</el-descriptions-item>
							</el-descriptions>
						</div>
					</template>
				</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<vs-pagination class="mt-4" :total="total" v-model="itemsPerPage"></vs-pagination>



	</div>
</template>
<script>
import Auditor from "@/components/Auditor.vue";

export default {
  components: {Auditor},
	data() {
		return {
			yearmonth: "", //时间段
			name: "",
			culturelist: [],
			total: 0,
			itemsPerPage: 1,
			id: '',
			status: "10",
			options: [],     //部门列表
			deptid: [],
			isexit: false,
			hasRejectRight: false,//有驳回权限
      hasEditAssessTime: false // 编辑考核时间权限
		}
	},
	mounted() {
		this.getoptions();
		this.getlist();
		this.getUserInfo();
	},
	watch: {
		itemsPerPage: 'getlist'
	},
	methods: {
		search() {
			this.itemsPerPage = 1;
			this.getlist();
		},
		reject(id) {
			console.log("id", id);
			const that = this;
			this.$api.ReturnSubmit({id: id}).then(function (response) {
				if (response.code == 0) {
					that.$vs.notify({
						title: "提示",
						color: 'success',
						text: response.message,
						position: 'top-center'
					});
					that.getlist();
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		getoptions() {	//获取部门列表
			const that = this;
			this.$api.getmember({}).then(function (response) {
				console.log("组织架构：", response);
				if (response.code == 0) {
					that.options = that.removeEmptyChildren(response.data);
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		//获取当前登录用户信息
		getUserInfo() {
			this.$api.getuserinfo({}).then(res => {  //获取当前登录用户信息
				if (res.data.menu && res.data.menu.length) {
					this.hasRejectRight = this.checkRight(res.data.menu, 'reject')
          this.hasEditAssessTime = this.checkRight(res.data.menu, 'editAssessTime')
        }
			})
		},
		//递归寻找菜单，是否存在驳回权限
		checkRight(menus, routeName) {
			let result = 0
      console.info(menus, routeName)
			for (let i = 0; i < menus.length; i++) {
				let item = menus[i]
				if (item.routeName === routeName) {
					result++
				} else if (item.children && item.children.length) {
					result += this.checkRight(item.children, routeName)
				}
			}
			return result > 0
		},
		removeEmptyChildren(node) {   //杀生
			var that = this;
			node.forEach(item => {
				if ('children' in item && item.children.length === 0) {
					delete item.children
				} else if ('children' in item && item.children.length) {
					that.removeEmptyChildren(item.children)
				}
			})
			return node;
		},
		reset() {
			this.yearmonth = [];
			this.status = "10";
			this.name = '';
			this.deptid = [];
			this.getlist();
		},
		exportexcel(id) {
			let token = localStorage.getItem('token');
			window.open(`${this.$baseURL}/staffAssess/conserve?id=${id}&authorization=${token}`);
		},
		getlist() {    //获取列表
			const thisIns = this;
			var start = thisIns.yearmonth[0] || '';
			var end = thisIns.yearmonth[1] || '';
			this.$api.queryHistoryRecord({
				pageNum: thisIns.itemsPerPage,
				pageSize: 10,
				status: thisIns.status,
				startTime: start,
				endTime: end,
				name: thisIns.name,
				deptId: thisIns.deptid[thisIns.deptid.length - 1]
			}).then(function (response) {
				console.log("列表数据：", response);
				if (response.code == 0) {
					// if (thisIns.status == 2 && thisIns.$store.state.AppActiveUser.inSys) {
					if (thisIns.status == 2 && thisIns.hasRejectRight) {
						thisIns.isexit = true;
					} else {
						thisIns.isexit = false
					}
					thisIns.culturelist = response.data.data;
					thisIns.total = response.data.pages;
				} else {
					thisIns.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		details(item) {  //详情
			localStorage.setItem("userdetails", JSON.stringify(item));
			//this.$router.push({path:'/admin/historydetails',query:{id:item.id}});
			let routeUrl = this.$router.resolve({path: '/admin/historydetails', query: {id: item.id}});
			window.open(routeUrl.href, '_blank');
		},
    editAssessTime(item) {
      var that = this;
      console.info(item)
      this.$prompt('考核时间，如：2025-02-12', '修改考核时间', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/,
        inputErrorMessage: '考核时间格式不正确，应为 YYYY-MM-DD'
      }).then(({ value }) => {

        var params = {
          id: item.id,
          assessTime: value
        }
        this.$api.postEditAssessTime(params).then(function (response) {
          if (response.code == 0) {
            that.$vs.notify({
              title: "提示",
              color: 'success',
              text: response.message,
              position: 'top-center'
            });
          } else {
            that.$vs.notify({
              title: "提示",
              color: 'warning',
              text: response.message,
              position: 'top-center'
            });
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
		exportall() {
			console.log("批量导出");
			var start = this.yearmonth[0] || '';
			var end = this.yearmonth[1] || '';
			let token = localStorage.getItem('token');
			let deptid = this.deptid.length > 0 ? this.deptid[this.deptid.length - 1] : "";
			window.open(`${this.$baseURL}/staffAssess/queryHistoryRecordExport?deptId=${deptid}&pageNum=1&pageSize=1000000&status=${this.status}&startTime=${start}&endTime=${end}&name=${this.name}&authorization=${token}`);
		},

	},
}
</script>
<style type="text/css">
.expandlabel {
	width: 200px;
}
</style>
